module.exports = __webpack_public_path__ + "static/img/A (4).95676164.png";